import { EnergyTypeI, FiltersInfoI, GenerationI, RegionI } from "interfaces";
import { useEffect, useState } from "react";
import { getFiltersInfo } from "../apis/pokemons";

export function useFetchFiltersInfo(): [
  GenerationI[],
  EnergyTypeI[],
  RegionI[],
  string
] {
  const [generation, setGeneration] = useState<GenerationI[]>([]);
  const [energyType, setEnergyType] = useState<EnergyTypeI[]>([]);
  const [region, setRegion] = useState<RegionI[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancel = false;
    async function fetchData() {
      try {
        const fetchedFiltersInfo: Omit<FiltersInfoI, "others"> =
          await getFiltersInfo();
        if (!cancel) {
          setGeneration(fetchedFiltersInfo.generations);
          setEnergyType(fetchedFiltersInfo.energyTypes);
          setRegion(fetchedFiltersInfo.regions);
        }
      } catch (error) {
        console.log("ERREUR");
        setError("Erreur");
      }
    }
    fetchData();
    return () => {
      cancel = true;
    };
  }, []);

  return [generation, energyType, region, error];
}
